<template>
  <b-modal
    :visible="visible"
    hide-header-close
    centered
    no-close-on-backdrop
    no-close-on-esc
  >
    <template #modal-title>
      {{ title }}
    </template>

    <div class="confirm-modal-message">
      {{ message }}
    </div>

    <div v-if="checkboxLabel" class="confirm-modal-option">
      <b-form-checkbox v-model="checkboxChecked">
        {{ checkboxLabel }}
      </b-form-checkbox>
      <small v-if="checkboxHelp" class="confirm-modal-option-help">
        {{ checkboxHelp }}
      </small>
    </div>

    <template #modal-footer>
      <b-button
        variant="outline-secondary"
        @click="handleCancel"
      >
        {{ cancelText }}
      </b-button>

      <b-button
        variant="primary"
        @click="handleConfirm"
      >
        {{ confirmText }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { BModal, BButton, BFormCheckbox } from 'bootstrap-vue'
export default {
  name: 'ConfirmModal',
  components: { BModal, BButton, BFormCheckbox },
  props: {
    visible: {
      type: Boolean,
      default: false
    },

    title: {
      type: String,
      default: 'Confirmação'
    },

    message: {
      type: String,
      required: true
    },

    checkboxLabel: {
      type: String,
      default: ''
    },

    checkboxHelp: {
      type: String,
      default: ''
    },

    cancelText: {
      type: String,
      default: 'Não'
    },

    confirmText: {
      type: String,
      default: 'Sim'
    }
  },

  data() {
    return {
      checkboxChecked: false
    }
  },

  watch: {
    visible(value) {
      if (value) {
        this.checkboxChecked = false
      }
    }
  },

  methods: {
    handleConfirm() {
      this.$emit('confirm', this.checkboxChecked)
    },

    handleCancel() {
      this.$emit('cancel')
    },

    handleHide(event) {
      event.preventDefault()
    }
  }
}
</script>

<style scoped>
.confirm-modal-message {
  font-size: 16px;
  line-height: 1.6;
  white-space: pre-line;
  max-height: 400px;
  overflow-y: auto;
}

.confirm-modal-option {
  margin-top: 20px;
  padding: 14px 16px;
  border-left: 4px solid var(--primary);
  border-radius: 0 4px 4px 0;
  background-color: #f4f3f9;
}

.confirm-modal-option ::v-deep .custom-control-label {
  color: #4b465c;
  font-weight: 600;
}

.confirm-modal-option-help {
  display: block;
  margin: 4px 0 0 24px;
  color: #5f5b6d;
  font-size: 13px;
  line-height: 1.45;
}
</style>